/**
 * 계층과 도메인에 무관한 wire datetime 파싱 계약.
 *
 * Owns:
 * - zone이 없는 backend ISO 문자열을 UTC로 해석하는 규칙.
 * - 비어 있거나 유효하지 않은 시각을 null로 정규화하는 규칙.
 *
 * Does not own:
 * - 화면별 날짜·시간 표시 형식 — 같은 폴더의 `format.ts`.
 * - 도메인별 duration과 상태 계산.
 */
export function parseUtcMs(iso: string | null): number | null {
  if (iso === null || iso === "") {
    return null;
  }
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(iso);
  const ms = Date.parse(hasZone ? iso : `${iso}Z`);
  return Number.isNaN(ms) ? null : ms;
}
